import {
  ApplicationBodyContainer,
  ApplicationBodyContent,
  PolicyTable,
  SectionCompleteImageContainer,
  DefaultBigTitle,
  ApplicationNextButtonsContainer,
  ApplicationBodyFooter
} from 'src/components/application/defaultComponents'
import trophyImg from 'src/assets/applicationFormsImgs/trophy.svg'
import { useRenewal } from 'src/context/renewal'
import { tlieSources } from 'src/constants/tlie'
import Button from 'src/components/basic/Button'
import { CompletedSubtitle, CompletedText } from './styles'
import {useEffect, useRef, useState} from 'react'
import DownloadSummaryButton from 'src/components/basic/DownloadSummaryButton'
import FullScreenLoading from 'src/components/basic/FullScreenLoading'
import Judge from '../Review/Judge'
import Questions from '../Review/Questions'
import QuotesSection from 'src/components/portal/default/AppListDrawerContent/QuotesSection'
import { ScreenshotsContainer } from 'src/components/application/ScreenshotsContainer/styles'
import {api} from "../../../../services/apiClient";

const { useScreenshot, createFileName } = require('use-react-screenshot');

const ApplicationSubmitted = () => {
  const { renewalData } = useRenewal()
  const screenshotsRef = useRef<any>(null);
  const [screenshot, takeScreenshot] = useScreenshot();
  const [showFullScreenLoading, setShowFullScreenLoading] = useState(false);
  const hasSentRef = useRef(false);
  const hasDownloadedImageRef = useRef(false);
  useEffect(() => {
    if (!screenshotsRef.current || hasSentRef.current) return;

    hasSentRef.current = true;
    const captureAndSendScreenshot = async () => {
      setShowFullScreenLoading(true);
      const summaryContainer = document.getElementById('summaryContainer');
      summaryContainer!.style.display = "block";

      const judgeData = document.getElementById('judgeData');
      const questionsData = document.getElementById('questionsData');
      const quotesSection = document.getElementById('quotesSection');
      const screenshotContainer = document.getElementById('screenshotContainer');
      judgeData && screenshotContainer?.appendChild(judgeData);
      questionsData && screenshotContainer?.appendChild(questionsData);
      quotesSection && screenshotContainer?.appendChild(quotesSection);

      judgeData!.style.height = "unset";
      questionsData!.style.height = "unset";
      questionsData!.style.marginTop = "50px";
      quotesSection!.style.marginTop = "50px";
      try {
        const image = await takeScreenshot(screenshotsRef.current);
        const name = "Application Summary";
        const extension = "jpg";
        const filename = `${name}.${extension}`;

        takeScreenshot(image); // Store for later download
        var request = {
          To: renewalData.applicant?.emailAddress,
          Files: [
            {Base64Image: image, Filename: filename}
          ]
        };
        
        await api.post(`/Notifications`, request);
      } catch (err) {
        console.error("Error capturing or sending screenshot", err);
      } finally {
        summaryContainer!.style.display = "none";
        setShowFullScreenLoading(false);
      }
    };

    if (screenshotsRef.current) {
      setShowFullScreenLoading(true);
      captureAndSendScreenshot();
    }
  }, [renewalData.applicant?.emailAddress, takeScreenshot]);
  const handleReturnToMainSite = () => {
    window.location.href = tlieSources.mainSiteUrl
  }

  const downloadSummary = () => {
    if (!screenshot || hasDownloadedImageRef.current) return;

    hasSentRef.current = true;

    const name = "Application Summary";
    const extension = "jpg";
    const filename = `${name}.${extension}`;

    const a = document.createElement("a");
    a.href = screenshot;
    a.download = filename;
    a.click();
    hasSentRef.current = false;
  }

  return (
    <ApplicationBodyContainer>
      <ApplicationBodyContent width='80%'>
        <DefaultBigTitle>Your renewal application has been submitted!</DefaultBigTitle>
        <br />
        <PolicyTable>
          <tbody>
            <tr>
              <td style={{ padding: 0 }}>
                <SectionCompleteImageContainer>
                  <img src={trophyImg} alt="Application Complete" />
                </SectionCompleteImageContainer>
              </td>
            </tr>
          </tbody>
        </PolicyTable>
        <br />
        <DownloadSummaryButton onClick={downloadSummary} />
        <div id='summaryContainer' style={{display: "none"}}>
          <ScreenshotsContainer id='screenshotContainer' ref={screenshotsRef}></ScreenshotsContainer>  
          <Judge screenshotMode/>
          <Questions screenshotMode/>
          <QuotesSection 
            quotesSection={renewalData.judgeApplicationData?.quoteData?.quotes}
            isComplete={false}/>
        </div>
        <FullScreenLoading active={showFullScreenLoading} />
        <br />
        <h2>What happens next?</h2><br /><br />
        <CompletedText>
          <p>
            TLIE's Underwriting Department will review your application and contact you with any additional questions. After your application is approved, we will email a premium quote to you for a new policy. The process usually takes 3 to 5 days after your complete application is received.
          </p><br />
          <p>
            In the meantime, please reach out with any question to&nbsp;
            <a href={`mailto:${tlieSources.infoEmail}`}>
              {tlieSources.infoEmail}
            </a>, send a chat at <a href={tlieSources.mainSiteUrl}>
              www.tlie.org
            </a>, or call <a href={`tel:${tlieSources.contactNumber}`}>
              {tlieSources.contactNumber}
            </a>. Someone will respond to you promptly.
          </p><br />
          <p>
            Thanks again for your interest in TLIE.
          </p>
        </CompletedText>
      </ApplicationBodyContent>
      <ApplicationBodyFooter>
        <div></div>
        <ApplicationNextButtonsContainer>
            <Button
              variant="primary"
              onClick={handleReturnToMainSite}
            >
              Return to TLIE.org
            </Button>
        </ApplicationNextButtonsContainer>
      </ApplicationBodyFooter>
    </ApplicationBodyContainer>
  )
}

export default ApplicationSubmitted